import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function branchesListRequest(urlParams = {}, requestConfig) {
  let url = urls.branchesList;

  if (urlParams.page) {
    url = urls.branchesListPaginated;
  }

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
    ...requestConfig,
  });
}

export async function branchesSearchRequest(urlParams = {}, requestConfig) {
  const url = urls.branchesListFiltered;

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
    ...requestConfig,
  });
}

export async function kompassBranchesListRequest(urlParams) {
  return request({
    method: 'get',
    url: urls.kompassBranchesList,
    urlParams,
    headers: getHeaders(),
  });
}

export async function branchCreateRequest(data) {
  return request({
    method: 'post',
    url: urls.branchCreate,
    data,
    headers: getHeaders(),
  });
}

export async function branchGetRequest(urlParams) {
  return request({
    method: 'get',
    url: urls.branchGet,
    urlParams,
    headers: getHeaders(),
  });
}

export async function branchUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.branchUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function branchRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.branchRemove,
    urlParams,
    headers: getHeaders(),
  });
}

export async function branchReplaceRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.branchReplace,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function downloadKompassBranchesRequest(urlParams) {
  return request({
    method: 'get',
    url: urls.downloadBranchesList,
    urlParams,
    responseType: 'arraybuffer',
    headers: getHeaders(),
  });
}

export async function searchClassificationCodes2ndLevelRequest(urlParams, requestConfig) {
  return request({
    method: 'get',
    url: urls.classificationCodes2ndLevelSearchByLabel,
    urlParams,
    headers: getHeaders(),
    ...requestConfig,
  });
}



// WEBPACK FOOTER //
// ./src/services/branches.js